import appStore from 'store';
import api from './api';
const store = {
  namespaced: true,
  state: {
    projects: [],
    coinTypeList: [],
    editingProject: null,
    // CycleList: [],
    changeCycle: null
  },
  getters: {},
  mutations: {
    setList(state, payload) {
      state.projects = payload;
    },
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },

    setEditingProject(state, payload) {
      state.editingProject = payload ? { ...payload } : null;
    },
    // setCycleList(state, payload) {
    //   state.CycleList = payload;
    // },
    setchangeCycle(state, payload) {
      state.changeCycle = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
      });
    },
    update(context, data) {
      return api.update(data);
    },
    remove(context, data) {
      return api.remove(data);
    },
    getCoinTypeList({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    },
    create(context, data) {
      return api.create(data);
    },
    createCycle(context, data) {
      return api.createCycle(data);
    },
    getCycleList(context, data) {
      return api.getCycleList(data);
      // api.getCycleList(query).then(({ data }) => {
      //   commit('setCycleList', data);
      // });
    },
    removeCycle(context, data) {
      return api.removeCycle(data);
    }
  }
};

appStore.registerModule('mortgage', store);
